import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api/API'
import { Message } from 'element-ui';
import config from '../api/config';


Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    loginData:JSON.parse(localStorage.getItem('loginData')) || {},
    isLogin:JSON.parse(localStorage.getItem('isLogin')) || false,
    allMenuRights:[],    //所有的菜单权限
    regionTree:[],        //地区树形菜单数据
    mapKey:'85029663258739101aff13a8a440cda9', //此处需要提供web API的key 并非 web js 的key
    navIndex:0,
    isFetching:false
  },
  actions:{
    getAllMenuRights({commit}){
      api.getAllMenuRights({}).then((res)=> {
        if (res.data.code=='OK' && res.data.data) {
          commit('setAllMenuRights',res.data.data);
        } else {
          //console.log(res.data.message);
        }
      });
    },
    getRegionTree(context){
      let obj={
        departId:context.state.loginData.departmentId
      };
      api.getRegionTree(obj).then((res)=> {
        if (res.data.code=='OK' && res.data.data) {
          context.commit('setRegionTree',[res.data.data]);
        } else {
          console.log(res.data.message);
        }
      });
    },
  },
  getters:{

  },
  mutations:{
    onClickButton(state){
      state.isFetching=true;
      setTimeout(()=>{ //延时指定时间后，再解冻
          state.isFetching = false;//执行请求后就不能点击了
      }, 1500);
    },
    //参数为state
    signOut(state){
      if (state.loginData && state.loginData.token){
        api.logout().then(res => {
          if (res.data.code === 'OK') {
            state.isLogin=false;
            state.loginData={};
            localStorage.removeItem('isLogin');
            localStorage.removeItem('loginData');
          } else {
            this.$message({
              type:'error',
              message:'退出失败,稍后重试!'
          });
          }
        }).catch(() => {
          this.$message({
            type:'error',
            message:'退出失败,稍后重试!'
        });
        })
      } else {
        state.isLogin=false;
        state.loginData={};
        localStorage.removeItem('isLogin');
        localStorage.removeItem('loginData');        
      }

    },
    signIn(state,res){
      state.isLogin=true;
      state.loginData=res;
      localStorage.setItem('isLogin',true);
      localStorage.setItem('loginData',JSON.stringify(res));
    },
    setUserInfor(state,res){
      state.loginData=res;
      localStorage.setItem('loginData',JSON.stringify(res));
    },
    setAllMenuRights(state,res){
      state.allMenuRights=res;
    },
    setRegionTree(state,res){
      state.regionTree=res;
    },
    setNavIndex(state,res){
      state.navIndex=res;
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js